import { App } from 'antd';
import Icon from '../../cpn/Icon';
import { useBaozhangdanDelMutation } from '../../store/DianShangYeWuApi';
function ReportDel(props) {
    const {modal,message} = App.useApp(); 
    const [submitDel] = useBaozhangdanDelMutation()  
    return (
        <Icon 
            type='delete' 
            onClick={() => {
                modal.confirm({
                    title: '点击确定将删除团队报账单',
                    content: '先删除团队报账单的收款单、付款单后才能删除团队报账单！',
                    okText: '确认',
                    okType: 'danger',
                    cancelText: '取消',
                    onOk() {
                        submitDel({
                            dsbzd_id:props.dsbzd_id,
                        }).then((res) => {
                            // console.log(res);
                            if (res.data.Status === 'success') {
                                message.info('删除成功！');
                            }
                            if (res.data.Status === "fail") {
                                message.error('删除失败！'+res.data.Message)
                            }
                        })
                    },
                    onCancel() {
                        // console.log('Cancel');
                    },
                }); 
            }}
        />
    )
}

export default ReportDel